import { ActionMenu } from "@telluscompany/design-system";
import { Edit, Trash2, MoreVertical } from "lucide-react";
import { useLocalization } from "@i18n";
import type { ListComplexesResponse } from "../../api/complexes/complexes.types";

interface ComplexesActionMenuProps {
  complex: ListComplexesResponse;
  onEdit: (complex: ListComplexesResponse) => void;
  onDelete: (complex: ListComplexesResponse) => void;
}

export const ComplexesActionMenu = ({
  complex,
  onEdit,
  onDelete,
}: ComplexesActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("management.complexes.button.edit"),
          onClick: () => onEdit(complex),
          icon: <Edit size={16} />,
        },
        {
          label: translate("management.complexes.button.delete"),
          onClick: () => onDelete(complex),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVertical size={20} />} />;
};
